
<p-toast position="top-right" key="save"></p-toast>
<div  #reportData id="reportData">
<div class="grid">
  <div class="col-12 relative">
    <div class="page mt-5 firstPageBorderTop" size="A4" landscape>
      <div class="grid justify-content-center">
        <img class="tele-logo" src="../../../../../assets/images/telespecialist-logo-01.png">
      </div>
        <div class="grid justify-content-center text-ts">
          <h1 class="text-qms">TeleSpecialists<br>
            Quality Management<br>
            System</h1>
          </div>
          <!-- <h3> -->
           <div class="health-alttext grid justify-content-center"  [innerHTML]="selectedOptionText"></div>
          <!-- </h3> -->
          <!-- <h2 class="bb-title">
          </h2> -->
          <h3 class="grid justify-content-center">
          <p class="ssline-quality">
            Stroke Service Line Quality Report, {{monthYear}}<br>
            {{selectedFilterType == 'system' ? 'System' : selectedFilterType == 'facility' ? 'Facility' : 'Regional'}} Dashboard Report
          </p>
        </h3>
       
    <div class="grid footer-image"></div>  
    </div>
  </div>
</div>

<div class="grid"  *ngFor="let t of graphImages.slice(0,3); let i = index" >
  <div class="col-12 relative">
    <div class="page firstPageBorderTop mt-2 improveReport" size="A4" landscape>
      <div class="pl-6 pr-6 pb-6">
        <p class="health-alttext-remaing"  [innerHTML]="selectedOptionText"></p>
          <div class="text-center w-full" *ngIf="chartFoundBool"><h4><b> No Data Available For Graphs </b></h4></div>
        <div>
          <!-- <div *ngIf="i === 0"> -->
          <img class="chart-img" [src]="t" alt="">
        <!-- </div> -->
        </div>
      </div>
            <div class="flex justify-content-end relative">
        <span class="page-number">{{i + 2}}</span>
      </div>
      <div class="grid footer-image-remaining"></div>  
    </div>
  </div>
</div>

<div class="grid"> 
  <div class="col-12 relative">
    <div class="page firstPageBorderTop mt-5 improveReport" size="A4" Landscape>
      <div class="pl-6 pr-6 pb-6">
        <p class="health-alttext-remaing"  [innerHTML]="selectedOptionText"></p>
        <p-table #dt [value]="bodyFacilityImprovefacilityList" styleClass="p-datatable-striped p-datatable-gridlines"
      sortMode="multiple" responsiveLayout="scroll" [rowHover]="true" sortMode="multiple"
      (sortFunction)="customSort($event)" [customSort]="true" [resizableColumns]="false">
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="QualityMetrics" pResizableColumn
          *ngFor="let headerFacilityList of headerFacilityImprovefacilityList" > {{headerFacilityList}} </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-bodyFacilityImprovefacilityList>
        <tr>
          <td *ngFor="let subBodyFacilityList of bodyFacilityImprovefacilityList"
            [style]="(subBodyFacilityList?.quality?.includes('Notification Mean') || (subBodyFacilityList?.quality?.includes('Notification Median')) 
                || (subBodyFacilityList?.quality?.includes('Notification Mean')) || (subBodyFacilityList?.quality?.includes('Notification Median'))
                || (subBodyFacilityList?.quality?.includes('Assessment')) || (subBodyFacilityList?.quality?.includes('Decision'))  ? 'color: white; background: #9f1f60;' : '')">
            {{subBodyFacilityList.quality}}</td>
          <td *ngFor="let subBodyFacilityList of bodyFacilityImprovefacilityList" [ngStyle]="getStyle(subBodyFacilityList, 'data1')">
            {{subBodyFacilityList.data1}}</td>
          <td *ngFor="let subBodyFacilityList of bodyFacilityImprovefacilityList" [ngStyle]="getStyle(subBodyFacilityList, 'data2')">
            {{subBodyFacilityList.data2}}</td>
          <td *ngFor="let subBodyFacilityList of bodyFacilityImprovefacilityList" [ngStyle]="getStyle(subBodyFacilityList, 'data3')">
            {{subBodyFacilityList.data3}}</td>
          <td *ngFor="let subBodyFacilityList of bodyFacilityImprovefacilityList" [ngStyle]="getStyle(subBodyFacilityList, 'data4')"
          >{{subBodyFacilityList.cumlative1}}</td>
          <td *ngFor="let subBodyFacilityList of bodyFacilityImprovefacilityList" [ngStyle]="getStyle(subBodyFacilityList, 'data5')"
          >{{subBodyFacilityList.cumlative2}}</td>
          <td *ngFor="let subBodyFacilityList of bodyFacilityImprovefacilityList" >{{subBodyFacilityList.goals3}}</td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <h5 *ngIf="totalFacilityComulativeDataRecord==0" class="text-center create-roles">
            <b> No records found</b>
          </h5>
        </tr>
      </ng-template>

    </p-table>
      </div>
      <!-- <div class="filterabletext">
        <span class="filtertable-text"> <b>Accomplishments/Improvements :</b> <label [innerHTML]="qti_accomplishments_improvements"></label> </span><br><br>
        <span class="filtertable-text"> <b>Opportunities and PI Projects :</b><label [innerHTML]="qti_opportunities_pi_projects"></label> </span>
      </div> -->
      <div class="flex justify-content-end relative">
        <span class="page-number">5</span>
      </div>
      <div class="grid footer-image-remaining"></div>  
    </div>
  </div>
</div>

<div class="grid">
  <div class="col-12 relative">
    <div class="page firstPageBorderTop mt-2 improveReport" size="A4" landscape>
      <div class="pl-6 pr-6 pb-6" style=" min-height: 40rem !important;">
        <p class="health-alttext-remaing"  [innerHTML]="selectedOptionText"></p>
          <div class="filterabletext">
            <span class="filtertable-text"> <b>Accomplishments/Improvements :</b><br><label [innerHTML]="qti_accomplishments_improvements"></label> </span><br><br>
            <span class="filtertable-text"> <b>Opportunities and PI Projects :</b><br><label [innerHTML]="qti_opportunities_pi_projects"></label> </span>
          </div>
      </div>
      <div class="flex justify-content-end relative">
        <span class="page-number">6</span>
      </div>
      <div class="grid footer-image-remaining"></div>  
    </div>
  </div>
</div>

<div class="grid" *ngFor="let t of graphImages.slice(3); let i = index">
  <div class="col-12 relative">
    <div class="page firstPageBorderTop mt-2 improveReport" size="A4" landscape>
      <div class="pl-6 pr-6 pb-6">
        <p class="health-alttext-remaing"  [innerHTML]="selectedOptionText"></p>
        <h1 *ngIf="i === 0" class="h-tag">GRAPHS</h1>
          <div class="text-center w-full" *ngIf="chartFoundBool"><h4><b> No Data Available For Graphs </b></h4></div>
        <div >
          <!-- <div *ngIf="i === 5"> -->
          <img class="chart-img" [src]="t" alt="">
        <!-- </div> -->
        </div>
      </div>
        <div class="flex justify-content-end relative">
        <span [ngClass]="i + 7 <= 9 ? 'page-number' : 'page-number-after-ten'">{{i + 7}}</span>
      </div>
      <div class="grid footer-image-remaining"></div>  
    </div>
  </div>
</div>

<div class="grid">
  <div class="col-12 relative">
    <div class="page firstPageBorderTop mt-5 improveReport" size="A4" Landscape>
      <div class="pl-6 pr-6 pb-6">
        <p class="health-alttext-remaing"  [innerHTML]="selectedOptionText"></p>
        <h1 class="rapidi-tag">RAPIDi Metric Outliers</h1>   
        <section>
          <ul>
            <!-- Activation -->
            <h3 class="outliers-heading"><b>Activation Time Interval</b></h3>
            <li class="mb-3"><span>Activation Time Interval outliers beyond benchmark for EMS cases (goal of <b>0</b> minutes)
              was <b>{{rapidiObj.activation.activationTimeListQualifyCountEMS}}</b> out of <b>{{rapidiObj.activation.activationTotalRecords}}</b> cases
              (<b>Maximum</b>: {{rapidiObj.activation.activationEMSTimeCasesMaximum}}; <b>Mean</b>: {{rapidiObj.activation.activationEMSTimeCasesMean}} ; <b>Median</b>:
              {{rapidiObj.activation.activationEMSTimeCasesMedian}})
            </span>
            </li>
            <li class="mb-3"><span>Activation Time Interval outliers beyond benchmark for Triage cases (goal of <b>10</b>
              minutes)
              was <b>{{rapidiObj.activation.activationTimeListQualifyCountTriage}}</b> out of <b>{{rapidiObj.activation.activationTgTotalRecords}}</b> cases
              (<b>Maximum</b>: {{rapidiObj.activation.activationTriageTimeCasesMaximum}}; <b>Mean</b>: {{rapidiObj.activation.activationTriageTimeCasesMean}} ; <b>Median</b>:
              {{rapidiObj.activation.activationTriageTimeCasesMedian}})
            </span>
            </li>
            <li class="mb-3"><span>From the EMS cases, {{rapidiObj.activation.WorkFlowTypePercentage}}% were called at pre-arrival.</span></li>
            <!-- Assessment -->
            <h3 class="outliers-heading"><b>Assessment Time Interval</b></h3>
            <li class="mb-3"><span>Assessment Time Interval outliers beyond benchmark for EMS cases (goal of <b>12</b> minutes)
              was <b>{{rapidiObj.assessment.assessmentTimeListQualifyCountEMS}}</b> out of <b>{{rapidiObj.assessment.assessmentTotalRecords}}</b> cases
              (<b>Maximum</b>: {{rapidiObj.assessment.assessmentEMSTimeCasesMaximum}}; <b>Mean</b>: {{rapidiObj.assessment.assessmentEMSTimeCasesMean}} ; <b>Median</b>:
              {{rapidiObj.assessment.assessmentEMSTimeCasesMedian}})
            </span>
            </li>
            <li class="mb-3">Assessment Time Interval outliers beyond benchmark for Inpatient cases (goal of <b>12</b>
              minutes)
              was <b>{{rapidiObj.assessment.assessmentTimeListQualifyCountInpatient}}</b> out of <b>{{rapidiObj.assessment.assessmentTotalInpatientRecords}}</b> cases
              (<b>Maximum</b>: {{rapidiObj.assessment.assessmentInpatientTimeCasesMaximum}}; <b>Mean</b>: {{rapidiObj.assessment.assessmentInpatientTimeCasesMean}} ; <b>Median</b>:
              {{rapidiObj.assessment.assessmentInpatientTimeCasesMedian}})
            </li>
            <li class="mb-3">Assessment Time Interval outliers beyond benchmark for Triage cases (goal of <b>12</b>
              minutes)
              was <b>{{rapidiObj.assessment.assessmentTimeListQualifyCountTriage}}</b> out of <b>{{rapidiObj.assessment.assessmentTotalTriageRecords}}</b> cases
              (<b>Maximum</b>: {{rapidiObj.assessment.assessmentTriageTimeCasesMaximum}}; <b>Mean</b>: {{rapidiObj.assessment.assessmentTriageTimeCasesMean}} ; <b>Median</b>:
              {{rapidiObj.assessment.assessmentTriageTimeCasesMedian}})
            </li>
            <li class="mb-3">Assessment Time Interval outliers beyond benchmark for ED Onset cases (goal of <b>12</b>
              minutes)
              was <b>{{rapidiObj.assessment.assessmentTimeListQualifyCountEDOnset}}</b> out of <b>{{rapidiObj.assessment.assessmentTotalEDOnsetRecords}}</b> cases
              (<b>Maximum</b>: {{rapidiObj.assessment.assessmentEDOnsetTimeCasesMaximum}}; <b>Mean</b>: {{rapidiObj.assessment.assessmentEDOnsetTimeCasesMean}} ; <b>Median</b>:
              {{rapidiObj.assessment.assessmentEDOnsetTimeCasesMedian}})
            </li>
            <!-- THROMBOLYTIC DECISION -->
            <h3 class="outliers-heading"><b>Thrombolytic Decision Time Interval</b></h3>
            <li class="mb-3"><span>Thrombolytic Decision Time Interval outliers beyond benchmark for EMS cases (goal of
              <b>10</b>
              minutes)
              was <b>{{rapidiObj.thrombolytic.thrombolyticDecisionTimeListQualifyCountEMS}}</b> out of
              <b>{{rapidiObj.thrombolytic.thrombolyticDecisionTotalRecords}}</b> cases (<b>Maximum</b>: {{rapidiObj.thrombolytic.thrombolyticDecisionEMSTimeCasesMaximum}};
              <b>Mean</b>: {{rapidiObj.thrombolytic.thrombolyticDecisionEMSTimeCasesMean}} ; <b>Median</b>: {{rapidiObj.thrombolytic.thrombolyticDecisionEMSTimeCasesMedian}})
            </span>
            </li>
            <li class="mb-3">Thrombolytic Decision Time Interval outliers beyond benchmark for Inpatient cases (goal of
              <b>10</b>
              minutes)
              was <b>{{rapidiObj.thrombolytic.thrombolyticDecisionTimeListQualifyCountInpatient}}</b> out of
              <b>{{rapidiObj.thrombolytic.thrombolyticDecisionTotalInpatientRecords}}</b> cases (<b>Maximum</b>: {{rapidiObj.thrombolytic.thrombolyticDecisionInpatientTimeCasesMaximum}};
              <b>Mean</b>: {{rapidiObj.thrombolytic.thrombolyticDecisionInpatientTimeCasesMean}} ; <b>Median</b>: {{rapidiObj.thrombolytic.thrombolyticDecisionInpatientTimeCasesMedian}})
            </li>
            <li class="mb-3">Thrombolytic Decision Time Interval outliers beyond benchmark for Triage cases (goal of
              <b>10</b>
              minutes)
              was <b>{{rapidiObj.thrombolytic.thrombolyticDecisionTimeListQualifyCountTriage}}</b> out of
              <b>{{rapidiObj.thrombolytic.thrombolyticDecisionTotalTriageRecords}}</b> cases (<b>Maximum</b>: {{rapidiObj.thrombolytic.thrombolyticDecisionTriageTimeCasesMaximum}};
              <b>Mean</b>: {{rapidiObj.thrombolytic.thrombolyticDecisionTriageTimeCasesMean}} ; <b>Median</b>: {{rapidiObj.thrombolytic.thrombolyticDecisionTriageTimeCasesMedian}})
            </li>
            <li class="mb-3">Thrombolytic Decision Time Interval outliers beyond benchmark for ED Onset cases (goal of
              <b>10</b>
              minutes)
              was <b>{{rapidiObj.thrombolytic.thrombolyticDecisionTimeListQualifyCountEDOnset}}</b> out of
              <b>{{rapidiObj.thrombolytic.thrombolyticDecisionEDOnsetRecords}}</b> cases (<b>Maximum</b>: {{rapidiObj.thrombolytic.thrombolyticDecisionEDOnsetTimeCasesMaximum}};
              <b>Mean</b>: {{rapidiObj.thrombolytic.thrombolyticDecisionEDOnsetTimeCasesMean}} ; <b>Median</b>: {{rapidiObj.thrombolytic.thrombolyticDecisionEDOnsetTimeCasesMedian}})
            </li>

          </ul>
        </section>
      </div>  
      <div class="flex justify-content-end relative">
        <span class="page-number-after-ten">17</span>
      </div>
      <div class="grid footer-image-remaining"></div>   
    </div>
  </div>
</div>

<div class="grid">
  <div class="col-12 relative">
    <div class="page firstPageBorderTop mt-5 improveReport" size="A4" Landscape>
      <div class="pl-6 pr-6 pb-6">
        <p class="health-alttext-remaing"  [innerHTML]="selectedOptionText"></p>   
    <section>
        <ul class="mb-5">
                      <!-- THROMBOLYTIC ADMINISTRATION -->
            <h3 class="outliers-heading"><b>Thrombolytic Administration Time Interval</b></h3>
            <li class="mb-3"><span>Thrombolytic Administration Time Interval outliers beyond benchmark for EMS cases (goal of
              <b>8</b>
              minutes) was <b>{{rapidiObj.thrombolyticAdministration.thrombolyticAdministrationTimeListQualifyCountEMS}}</b> out of
              <b>{{rapidiObj.thrombolyticAdministration.thrombolyticAdministrationTotalRecords}}</b> cases (<b>Maximum</b>:
              {{rapidiObj.thrombolyticAdministration.thrombolyticAdministrationEMSTimeCasesMaximum}}; <b>Mean</b>: {{rapidiObj.thrombolyticAdministration.thrombolyticAdministrationEMSTimeCasesMean}} ;
              <b>Median</b>: {{rapidiObj.thrombolyticAdministration.thrombolyticAdministrationEMSCasesMedian}})
            </span>
            </li>
            <li class="mb-3">Thrombolytic Administration Time Interval outliers beyond benchmark for Inpatient cases
              (goal of <b>8</b>
              minutes) was <b>{{rapidiObj.thrombolyticAdministration.thrombolyticAdministrationTimeListQualifyCountInpatient}}</b> out of
              <b>{{rapidiObj.thrombolyticAdministration.thrombolyticAdministrationTotalInpatientRecords}}</b> cases (<b>Maximum</b>:
              {{rapidiObj.thrombolyticAdministration.thrombolyticAdministrationInpatientTimeCasesMaximum}}; <b>Mean</b>: {{rapidiObj.thrombolyticAdministration.thrombolyticAdministrationInpatientTimeCasesMean}} ;
              <b>Median</b>: {{rapidiObj.thrombolyticAdministration.thrombolyticAdministrationInpatientTimeCasesMedian}})
            </li>
            <li class="mb-3">Thrombolytic Administration Time Interval outliers beyond benchmark for Triage cases
              (goal of <b>8</b>
              minutes) was <b>{{rapidiObj.thrombolyticAdministration.thrombolyticAdministrationTimeListQualifyCountTriage}}</b> out of
              <b>{{rapidiObj.thrombolyticAdministration.thrombolyticAdministrationTotalTriageRecords}}</b> cases (<b>Maximum</b>:
              {{rapidiObj.thrombolyticAdministration.thrombolyticAdministrationTriageTimeCasesMaximum}}; <b>Mean</b>: {{rapidiObj.thrombolyticAdministration.thrombolyticAdministrationTriageTimeCasesMean}} ;
              <b>Median</b>: {{rapidiObj.thrombolyticAdministration.thrombolyticAdministrationTriageTimeCasesMedian}})
            </li>
            <li class="mb-3">Thrombolytic Administration Time Interval outliers beyond benchmark ED Onset cases
              (goal of <b>8</b>
              minutes) was <b>{{rapidiObj.thrombolyticAdministration.thrombolyticAdministrationTimeListQualifyCountEDOnset}}</b> out of
              <b>{{rapidiObj.thrombolyticAdministration.thrombolyticAdministrationTotalEDOnsetRecords}}</b> cases (<b>Maximum</b>:
              {{rapidiObj.thrombolyticAdministration.thrombolyticAdministrationEDOnsetTimeCasesMaximum}}; <b>Mean</b>: {{rapidiObj.thrombolyticAdministration.thrombolyticAdministrationEDOnsetTimeCasesMean}} ;
              <b>Median</b>: {{rapidiObj.thrombolyticAdministration.thrombolyticAdministrationEDOnsetTimeCasesMedian}})
            </li>

            <!-- Summary of Opportunities -->
          <h3 class="outliers-heading"><b>{{headingSummaryOportunity}}</b></h3>
          <li class="mb-3" *ngFor="let improvedata of improveAHAAHASFL"><span>{{improvedata.QualityMetrics}} was at
          <b
            [style]="((improvedata?.QualityMetrics?.includes('%') || improvedata?.QualityMetrics?.includes('10')) && improvedata.commonDataR < improvedata.commonGoalsR && !improvedata?.QualityMetrics?.includes('#')) || (!(improvedata?.QualityMetrics?.includes('%') || improvedata?.QualityMetrics?.includes('10')) && improvedata.commonDataR > improvedata.commonGoalsR && !improvedata?.QualityMetrics?.includes('#')) ? 'color: red; font-weight: bold;' : ''">{{improvedata.commonData}}</b>
          <span
            *ngIf="!(improvedata.QualityMetrics.includes('#') ||improvedata.commonData?.toString().includes('%'))">
            minutes</span> <span *ngIf="improvedata.commonGoals">{{!(improvedata.commonData.includes('%')) ?
            ' (goal of less
            than ' + improvedata.commonGoals + ')': ' (goal of more than ' + improvedata.commonGoals + ')'}}</span>
          </span>
        </li>

          <li class="mb-3" *ngFor="let improvedata of improveAHAAHASFL2">
            <span>{{improvedata.QualityMetrics}} was at
            <b [style]="((improvedata?.QualityMetrics?.includes('%') || improvedata?.QualityMetrics?.includes('10')) && improvedata.commonDataR < improvedata.commonGoalsR && !improvedata?.QualityMetrics?.includes('#')) || (!(improvedata?.QualityMetrics?.includes('%') || improvedata?.QualityMetrics?.includes('10')) && improvedata.commonDataR > improvedata.commonGoalsR && !improvedata?.QualityMetrics?.includes('#')) ? 'color: red; font-weight: bold;' : ''">{{improvedata.commonData}}</b>
            
              <span *ngIf="!(improvedata.commonData?.toString()).includes('%')"> minutes</span> <span
              *ngIf="improvedata.commonGoals">{{!(improvedata.commonData.includes('%')) ? ' (goal of less
              than ' + improvedata.commonGoals + ')': ' (goal of more than ' + improvedata.commonGoals + ')'}}</span> 
            </span>
          </li>

          <li class="mb-3" *ngFor="let improvedata of activationToNeedleArray"><span><span
            [innerHTML]="improvedata.QualityMetrics"></span> was at
          <b
            [style]="((improvedata?.QualityMetrics?.includes('%') || improvedata?.QualityMetrics?.includes('10')) && improvedata.commonDataR < improvedata.commonGoalsR && !improvedata?.QualityMetrics?.includes('#')) || (!(improvedata?.QualityMetrics?.includes('%') || improvedata?.QualityMetrics?.includes('10')) && improvedata.commonDataR > improvedata.commonGoalsR && !improvedata?.QualityMetrics?.includes('#')) ? 'color: red; font-weight: bold;' : ''">{{improvedata.commonData}}</b>
          <span *ngIf="!(improvedata.commonData?.toString()).includes('%')"> minutes</span>
        </span>
        </li>

        <h3 class="outliers-heading"><b>Activation (measure of hospital activation of TS):</b></h3>
        <li class="mb-3" *ngFor="let improvedata of improveAData"><span><span
            [innerHTML]="improvedata.QualityMetrics"></span> was at
          <b
            [style]="((improvedata?.QualityMetrics?.includes('%') || improvedata?.QualityMetrics?.includes('10')) && improvedata.commonDataR < improvedata.commonGoalsR && !improvedata?.QualityMetrics?.includes('#')) || (!(improvedata?.QualityMetrics?.includes('%') || improvedata?.QualityMetrics?.includes('10')) && improvedata.commonDataR > improvedata.commonGoalsR && !improvedata?.QualityMetrics?.includes('#')) ? 'color: red; font-weight: bold;' : ''">{{improvedata.commonData}}</b>
          <span *ngIf="!(improvedata.commonData?.toString()).includes('%')"> minutes</span> <span
            *ngIf="improvedata.commonGoals">{{!(improvedata.commonData.includes('%')) ? ' (goal of less
            than ' + improvedata.commonGoals + ')': ' (goal of more than ' + improvedata.commonGoals + ')'}}</span>
          </span>
        </li>

        <!-- <h3 class="outliers-heading"><b>Notification to TS initial response (measure of TS response):</b></h3>
        <li class="mb-3" *ngFor="let improvedata of improveAAData"><span><span
            [innerHTML]="improvedata.QualityMetrics"></span> was at
          <b
            [style]="((improvedata?.QualityMetrics?.includes('%') || improvedata?.QualityMetrics?.includes('10')) && improvedata.commonDataR < improvedata.commonGoalsR && !improvedata?.QualityMetrics?.includes('#')) || (!(improvedata?.QualityMetrics?.includes('%') || improvedata?.QualityMetrics?.includes('10')) && improvedata.commonDataR > improvedata.commonGoalsR && !improvedata?.QualityMetrics?.includes('#')) ? 'color: red; font-weight: bold;' : ''">{{improvedata.commonData}}</b>
          <span *ngIf="!(improvedata.commonData?.toString()).includes('%')"> minutes</span> <span
            *ngIf="improvedata.commonGoals">{{!(improvedata.commonData.includes('%')) ? ' (goal of less
            than ' + improvedata.commonGoals + ')': ' (goal of more than ' + improvedata.commonGoals + ')'}}</span>
          </span>
        </li>

        <h3 class="outliers-heading"><b>Activation to Assessment (measure of teleneurology ability to assess the patient after activation):</b></h3>
        <li class="mb-3" *ngFor="let improvedata of improveNData"><span><span
            [innerHTML]="improvedata.QualityMetrics"></span> was at
          <b
            [style]="((improvedata?.QualityMetrics?.includes('%') || improvedata?.QualityMetrics?.includes('10')) && improvedata.commonDataR < improvedata.commonGoalsR && !improvedata?.QualityMetrics?.includes('#')) || (!(improvedata?.QualityMetrics?.includes('%') || improvedata?.QualityMetrics?.includes('10')) && improvedata.commonDataR > improvedata.commonGoalsR && !improvedata?.QualityMetrics?.includes('#')) ? 'color: red; font-weight: bold;' : ''">{{improvedata.commonData}}</b>
          <span *ngIf="!(improvedata.commonData?.toString()).includes('%')"> minutes</span> <span
            *ngIf="improvedata.commonGoals">{{!(improvedata.commonData.includes('%')) ? ' (goal of less
            than ' + improvedata.commonGoals + ')': ' (goal of more than ' + improvedata.commonGoals + ')'}}</span>
          </span>
        </li>

        <h3 class="outliers-heading"><b>Assessment to Thrombolytic Decision<br>(measure of teams ability to obtain critical information for
            decision, and physicians decision to administer thrombolytic after all information is obtained for
            decision):</b></h3>
        <li class="mb-3" *ngFor="let improvedata of improveATData"><span><span
            [innerHTML]="improvedata.QualityMetrics"></span> was at
          <b
            [style]="((improvedata?.QualityMetrics?.includes('%') || improvedata?.QualityMetrics?.includes('10')) && improvedata.commonDataR < improvedata.commonGoalsR && !improvedata?.QualityMetrics?.includes('#')) || (!(improvedata?.QualityMetrics?.includes('%') || improvedata?.QualityMetrics?.includes('10')) && improvedata.commonDataR > improvedata.commonGoalsR && !improvedata?.QualityMetrics?.includes('#')) ? 'color: red; font-weight: bold;' : ''">{{improvedata.commonData}}</b>
          <span *ngIf="!(improvedata.commonData?.toString()).includes('%')"> minutes</span> <span
            *ngIf="improvedata.commonGoals">{{!(improvedata.commonData.includes('%')) ? ' (goal of less
            than ' + improvedata.commonGoals + ')': ' (goal of more than ' + improvedata.commonGoals + ')'}}</span>
          </span>
        </li>

        <h3 class="outliers-heading"><b>Thrombolytic Decision to Administration (measure of speed of administration of thrombolytic by team
            after decision):</b></h3>
        <li class="mb-3" *ngFor="let improvedata of improveTAMHATS"><span><span
            [innerHTML]="improvedata.QualityMetrics"></span> was at
          <b
            [style]="((improvedata?.QualityMetrics?.includes('%') || improvedata?.QualityMetrics?.includes('10')) && improvedata.commonDataR < improvedata.commonGoalsR && !improvedata?.QualityMetrics?.includes('#')) || (!(improvedata?.QualityMetrics?.includes('%') || improvedata?.QualityMetrics?.includes('10')) && improvedata.commonDataR > improvedata.commonGoalsR && !improvedata?.QualityMetrics?.includes('#')) ? 'color: red; font-weight: bold;' : ''">{{improvedata.commonData}}</b>
          <span *ngIf="!(improvedata.commonData?.toString()).includes('%')"> minutes</span> <span
            *ngIf="improvedata.commonGoals">{{!(improvedata.commonData.includes('%')) ? ' (goal of less
            than ' + improvedata.commonGoals + ')': ' (goal of more than ' + improvedata.commonGoals + ')'}}</span>
          </span>
        </li> -->
        </ul>
      </section>
      </div>    
      <div class="flex justify-content-end relative">
        <span class="page-number-after-ten">18</span>
      </div>
      <div class="grid footer-image-remaining"></div>   
    </div>
  </div>
</div>
<div class="grid">
  <div class="col-12 relative">
    <div class="page firstPageBorderTop mt-5 improveReport" size="A4" Landscape>
      <div class="pl-6 pr-6 pb-6">
        <p class="health-alttext-remaing"  [innerHTML]="selectedOptionText"></p>   
    <section>
        <ul class="mb-5">
        <h3 class="outliers-heading"><b>Notification to TS initial response (measure of TS response):</b></h3>
        <li class="mb-3" *ngFor="let improvedata of improveAAData"><span><span
            [innerHTML]="improvedata.QualityMetrics"></span> was at
          <b
            [style]="((improvedata?.QualityMetrics?.includes('%') || improvedata?.QualityMetrics?.includes('10')) && improvedata.commonDataR < improvedata.commonGoalsR && !improvedata?.QualityMetrics?.includes('#')) || (!(improvedata?.QualityMetrics?.includes('%') || improvedata?.QualityMetrics?.includes('10')) && improvedata.commonDataR > improvedata.commonGoalsR && !improvedata?.QualityMetrics?.includes('#')) ? 'color: red; font-weight: bold;' : ''">{{improvedata.commonData}}</b>
          <span *ngIf="!(improvedata.commonData?.toString()).includes('%')"> minutes</span> <span
            *ngIf="improvedata.commonGoals">{{!(improvedata.commonData.includes('%')) ? ' (goal of less
            than ' + improvedata.commonGoals + ')': ' (goal of more than ' + improvedata.commonGoals + ')'}}</span>
          </span>
        </li>

        <h3 class="outliers-heading"><b>Activation to Assessment (measure of teleneurology ability to assess the patient after activation):</b></h3>
        <li class="mb-3" *ngFor="let improvedata of improveNData"><span><span
            [innerHTML]="improvedata.QualityMetrics"></span> was at
          <b
            [style]="((improvedata?.QualityMetrics?.includes('%') || improvedata?.QualityMetrics?.includes('10')) && improvedata.commonDataR < improvedata.commonGoalsR && !improvedata?.QualityMetrics?.includes('#')) || (!(improvedata?.QualityMetrics?.includes('%') || improvedata?.QualityMetrics?.includes('10')) && improvedata.commonDataR > improvedata.commonGoalsR && !improvedata?.QualityMetrics?.includes('#')) ? 'color: red; font-weight: bold;' : ''">{{improvedata.commonData}}</b>
          <span *ngIf="!(improvedata.commonData?.toString()).includes('%')"> minutes</span> <span
            *ngIf="improvedata.commonGoals">{{!(improvedata.commonData.includes('%')) ? ' (goal of less
            than ' + improvedata.commonGoals + ')': ' (goal of more than ' + improvedata.commonGoals + ')'}}</span>
          </span>
        </li>

        <h3 class="outliers-heading"><b>Assessment to Thrombolytic Decision<br>(measure of teams ability to obtain critical information for
            decision, and physicians decision to administer thrombolytic after all information is obtained for
            decision):</b></h3>
        <li class="mb-3" *ngFor="let improvedata of improveATData"><span><span
            [innerHTML]="improvedata.QualityMetrics"></span> was at
          <b
            [style]="((improvedata?.QualityMetrics?.includes('%') || improvedata?.QualityMetrics?.includes('10')) && improvedata.commonDataR < improvedata.commonGoalsR && !improvedata?.QualityMetrics?.includes('#')) || (!(improvedata?.QualityMetrics?.includes('%') || improvedata?.QualityMetrics?.includes('10')) && improvedata.commonDataR > improvedata.commonGoalsR && !improvedata?.QualityMetrics?.includes('#')) ? 'color: red; font-weight: bold;' : ''">{{improvedata.commonData}}</b>
          <span *ngIf="!(improvedata.commonData?.toString()).includes('%')"> minutes</span> <span
            *ngIf="improvedata.commonGoals">{{!(improvedata.commonData.includes('%')) ? ' (goal of less
            than ' + improvedata.commonGoals + ')': ' (goal of more than ' + improvedata.commonGoals + ')'}}</span>
          </span>
        </li>

        <h3 class="outliers-heading"><b>Thrombolytic Decision to Administration (measure of speed of administration of thrombolytic by team
            after decision):</b></h3>
        <li class="mb-3" *ngFor="let improvedata of improveTAMHATS"><span><span
            [innerHTML]="improvedata.QualityMetrics"></span> was at
          <b
            [style]="((improvedata?.QualityMetrics?.includes('%') || improvedata?.QualityMetrics?.includes('10')) && improvedata.commonDataR < improvedata.commonGoalsR && !improvedata?.QualityMetrics?.includes('#')) || (!(improvedata?.QualityMetrics?.includes('%') || improvedata?.QualityMetrics?.includes('10')) && improvedata.commonDataR > improvedata.commonGoalsR && !improvedata?.QualityMetrics?.includes('#')) ? 'color: red; font-weight: bold;' : ''">{{improvedata.commonData}}</b>
          <span *ngIf="!(improvedata.commonData?.toString()).includes('%')"> minutes</span> <span
            *ngIf="improvedata.commonGoals">{{!(improvedata.commonData.includes('%')) ? ' (goal of less
            than ' + improvedata.commonGoals + ')': ' (goal of more than ' + improvedata.commonGoals + ')'}}</span>
          </span>
        </li>
        </ul>
      </section>
      </div>    
      <div class="flex justify-content-end relative">
        <span class="page-number-after-ten">19</span>
      </div>
      <div class="grid footer-image-remaining"></div>   
    </div>
  </div>
</div>

</div>

